// Accent style helpers for dynamic theming
// Use these instead of Tailwind arbitrary values with CSS variables

export function accentBg() {
  return { backgroundColor: "var(--accent)" };
}

export function accentBgHover() {
  return { backgroundColor: "var(--accent-hover)" };
}

export function accentBgLight() {
  return { backgroundColor: "var(--accent-light)" };
}

export function accentText() {
  return { color: "var(--accent)" };
}

export function accentBorder() {
  return { borderColor: "var(--accent)" };
}

export function accentGradient() {
  return { background: "linear-gradient(to right, var(--accent), var(--accent-hover))" };
}

// Laranja do logotipo (#FF9945) — usado nas ações do apoio rápido
export function brandOrangeBg() {
  return { backgroundColor: "var(--brand-orange)" };
}

export function brandOrangeText() {
  return { color: "var(--brand-orange)" };
}

export function accentShadow() {
  return { boxShadow: "0 10px 15px -3px var(--accent-light)" };
}
